import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  DsBoxModule,
  DsButtonModule,
  DsColumnData,
  DsDatepickerConfiguration,
  DsDatepickerModule,
  DsFormFieldModule,
  DsIconModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsProgressCircleModule,
  DsRowData,
  DsTableConfig,
  DsTableModule,
  DsToastModel,
  DsToastService,
} from '@bmw-ds/components';
import {FormsModule} from '@angular/forms';
import {CreateGoodsMvtRequest} from '../../models/create-goods-request.model';
import {UploadFinanceDocModel, UploadFinanceDocResponse,} from '../../models/upload-finance-doc.model';
import {StockService} from '../../services/stock.service';
import {GoodsMovementService} from '../../services/goods.service';
import {TestDriveRequestModel} from '../../models/test-drive-request.model';
import {DemoInspectionRequest} from '../../models/request-inspection.model';
import {RequestQuoteComponent} from '../modals/requestQuote/request-quote.component';
import {CampaignDetailsComponent} from '../modals/campaignDetails/campaign-details.component';
import {InspectionDocRequest} from '../../models/inspection-doc-request.model';
import {RouterModule} from '@angular/router';
import {COMMON_IMPORTS} from "../../shared/common-imports";
import {AuthService} from "../../services/auth.service";
import {UserInfoService} from '../../services/user-info.service';
import { UploadLicenseDocsRequest } from '../../models/upload-license-docs.model';


@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    DsTableModule,
    CommonModule,
    FormsModule,
    DsIconModule,
    DsBoxModule,
    DsModalModule,
    DsFormFieldModule,
    RequestQuoteComponent,
    CampaignDetailsComponent,
    RouterModule,
    DsButtonModule,
    DsProgressCircleModule,
    COMMON_IMPORTS,
    DsDatepickerModule,
  ],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  selectedVehicle: any;

  @Input() rowsData: DsRowData[] = [];
  @Input() columnData: DsColumnData[] = [];
  @Input() showTable: boolean = false;
  @ViewChild(RequestQuoteComponent)
  requestQuoteComponent!: RequestQuoteComponent;
  private readonly cdr = inject(ChangeDetectorRef);
  @ViewChild(CampaignDetailsComponent)
  campaignDetails!: CampaignDetailsComponent;

  constructor(
    private stockService: StockService,
    private goodsMovementService: GoodsMovementService,
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService,
    private authService: AuthService,
    private userInfoService: UserInfoService
  ) {}

  @Output() downloadClick = new EventEmitter<string | number>();
  @Output() transferClick = new EventEmitter<CreateGoodsMvtRequest>();

  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };

  modalData = {
    modelCode: '',
    vin: '',
  };
  modalOTPData = {
    modelCode: '',
    vin: '',
    dspReference: '',
  };
  modalResponseData = {
    title: '',
    message: '',
  };
  updateMileageRequest: TestDriveRequestModel = {
    vin: '',
    statusCode: '',
    km: '',
    text: '',
  };
  // @Output() configChange = new EventEmitter<any>();
  inspectionDocRequest: InspectionDocRequest = {
    tuvSudReferenceNumber: '',
    bmwOrderNumber: '',
  };

  goodsMvtRequest: CreateGoodsMvtRequest = {
    domainReferer: '',
    accessToken: '',
    vin: '',
    storageLocation: '',
    itemText: '',
    materialNumber: '',
    plantMovement: '',
    storageLocationMovement: '',
    movementType: '',
    plant: '',
  };
  uploadFinanceDocModel: UploadFinanceDocModel = {
    documentType: '',
    quoteId: '',
    dspOrder: '',
    uploadViewIndicator: '',
    financeDocument: '',
    dealerCode: localStorage.getItem('dealerCode') || '',
  };
  inspectionRequest: DemoInspectionRequest = {
    appointmentDate: '',
    appointmentTime: '',
    vin: '',
    productKey: '',
    comments: '',
    documents: '',
  };
  // financeDocument: FinanceDocument = {
  //   fileName: '',
  //   fileContent: null,
  // };
  config: Partial<DsTableConfig> = {
    hasColumnDivider: true,
    hasStickyHeader: true,
    hasZebraRows: true,
  };
  modalIsOpen: boolean = false;
  model: File | null = null;
  mileageModel: string = '';
  otpModalIsOpen: boolean = false;

  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }

  onDownloadClick(vin: string | number): void {
    this.downloadClick.emit(vin);
  }

  onKeyDown(
    event: KeyboardEvent,
    vin: string | number,
    method: 'download' | 'transfer',
    model?: string | number
  ): void {
    if (event.key === 'Enter' || event.key === ' ') {
      if (method === 'download') {
        this.onDownloadClick(vin);
      } else if (method === 'transfer' && model) {
        this.transferVehicle(vin, model);
      }
      event.preventDefault();
    }
  }

  openRequestQuoteModal(vin: string | number): void {
    this.requestQuoteComponent.modalData.vin = vin.toString();
    this.requestQuoteComponent.modalData.requesterName =
      this.userInfoService.getUserName() || this.userInfoService.getUserId();
    this.requestQuoteComponent.demoStockReplshModalIsOpen = true;
  }

  transferVehicle(vin: string | number, modelCode: string | number): void {
    const hostname = window.location.hostname;
    if (hostname.endsWith('.com')) {
      this.goodsMvtRequest.domainReferer = 'com'
    }
    if (hostname.endsWith('.net')) {
      this.goodsMvtRequest.domainReferer = 'net'
    }
    // this.goodsMvtRequest.domainReferer = 'net' //localhost
    this.goodsMvtRequest.accessToken = this.authService.getAccessToken() || '';
    this.goodsMvtRequest.materialNumber = modelCode.toString();
    this.goodsMvtRequest.vin = vin.toString();
    this.goodsMvtRequest.storageLocation = 'BASE';
    this.goodsMvtRequest.storageLocationMovement = 'SHWR';
    this.goodsMvtRequest.plantMovement = localStorage.getItem('plantCode') || '';
    this.goodsMvtRequest.movementType = '311';
    this.goodsMvtRequest.plant = localStorage.getItem('plantCode') || '';
    this.modalIsOpen = false;
    this.transferClick.emit(this.goodsMvtRequest);
  }

  modalClickData(vin: string | number, modelCode: string | number): void {
    this.modalData.vin = vin ? vin.toString() : '';
    this.modalData.modelCode = modelCode ? modelCode.toString() : '';
    this.modalIsOpen = true;
  }

  modalOTPClickData(
    vin: string | number,
    modelCode: string | number,
    dspReference: string | number
  ) {
    this.model = null;
    this.modalOTPData.vin = vin.toString();
    this.modalOTPData.modelCode = modelCode.toString();
    this.modalOTPData.dspReference = dspReference.toString();
    // this.otpUploadComponent.otpModalIsOpen = true;
    this.otpModalIsOpen = true;
  }

  selectedFile: File | null = null;
  base64FileContent: string | null = null;
  responseModalIsOpen: boolean = false;
  inBoundmodalIsOpen: boolean = false;
  updatedMileage: string = '';
  inBoundmodalData = {
    title: '',
    message: '',
  };
  demoMileageModalIsOpen: boolean = false;
  demoMileageModalData = {
    modelDescription: '',
    currentMileage: '',
    vin: '',
  };
  isMileageGreater: boolean = false;
  requestInspectionModalIsOpen: boolean = false;
  requestInspectionModalData = {
    vin: '',
    modelDescription: '',
    appraisalStatus: '',
  };
  inspectionDateModel: string = '';
  inspectionTimeModel: string = '';

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.base64FileContent = (reader.result as string).split(',')[1];
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  uploadFinanceDocument(
    vin: string,
    modelCode: string,
    dspReference: string | number
  ) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Uploading Finance Documentation',
    };
    this.uploadFinanceDocModel.quoteId = vin.toString();
    this.uploadFinanceDocModel.dspOrder = dspReference.toString();
    this.uploadFinanceDocModel.documentType = 'POF';
    this.uploadFinanceDocModel.uploadViewIndicator = 'U';
    this.uploadFinanceDocModel.financeDocument = this.base64FileContent;

    console.log(this.uploadFinanceDocModel);
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.stockService.uploadDocument(this.uploadFinanceDocModel).subscribe(
      (response: UploadFinanceDocResponse) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.otpModalIsOpen = false;
        this.addToast('positive', response.message);
        this.base64FileContent = '';
        this.selectedFile = null;
        console.log('Document uploaded successfully:', response);
      },
      (error: unknown) => {
        this.base64FileContent = '';
        this.selectedFile = null;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.log(error);
        this.addToast('critical', 'Document Upload failed');
      }
    );
  }

  viewFinanceDocumentation(
    vin: string | number,
    dspReference: string | number
  ) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Downloading Finance Documentation',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    let dealerCode = localStorage.getItem('dealerCode') ?? '';
    this.stockService
        .viewDocument(vin.toString(), dspReference.toString(), dealerCode)
      .subscribe(
        (response: UploadFinanceDocResponse) => {
          console.log('Documentation view finance documentation:', response);

          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);

          const decodedDoc = atob(response.financeDocument.toString()); // Decode the Base64 string
          const byteArray = new Uint8Array(decodedDoc.length);
          for (let i = 0; i < decodedDoc.length; i++) {
            byteArray[i] = decodedDoc.charCodeAt(i);
          }
          const blob = new Blob([byteArray], {
            type: 'application/pdf',
          });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        },
        (error: unknown) => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          console.error('Failed to view finance documentation:', error);
        }
      );
  }

  acceptInboundVehicle(vin: string | number) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Accepting Vehicle Inbound',
    };
    const hostname = window.location.hostname;
    if (hostname.endsWith('.com')) {
      this.goodsMvtRequest.domainReferer = 'com';
    }
    if (hostname.endsWith('.net')) {
      this.goodsMvtRequest.domainReferer = 'net';
    }
    // this.goodsMvtRequest.domainReferer = 'net';
    this.goodsMvtRequest.accessToken = this.authService.getAccessToken() || '';
    this.goodsMvtRequest.vin = vin.toString();
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

    this.goodsMovementService
      .createGoodsInbound(this.goodsMvtRequest)
      .subscribe(
        (response) => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.inBoundmodalData.title = 'Inbound Vehicle Acceptance';

          console.log('Inbound Vehicle Accepted ', response);
          this.inBoundmodalData.message = response.message1;
          this.inBoundmodalIsOpen = true;
          this.showInboundFooter = true;
        },
        (error) => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          console.error('Error transferring vehicle:', error);
          this.inBoundmodalData.title = 'Error';
          this.inBoundmodalData.message = 'Error accepting vehicle inbound';
          this.showInboundFooter = true;
        }
      );
  }

  close() {
    this.responseModalIsOpen = false;
    this.inBoundmodalIsOpen = false;
    this.modalIsOpen = false;
  }

  isAppraisalStatusUploaded(appraisalStatus: string | number): boolean {
    return (
      appraisalStatus === 'Report Uploaded' ||
      appraisalStatus === 'Addendum Uploaded'
    );
  }

  isItemValid(
    lastAction: string | number,
    docIndicator: string | number
  ): boolean {
    return (
      lastAction !== 'INVOICED' &&
      lastAction !== 'AWAITING' &&
      docIndicator !== 'G'
    );
  }

  onTextChange($event: Event) {
    const input = $event.target as HTMLInputElement;
    const value = input.value;
    this.updatedMileage = value.toString();
  }

  updateMileage() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Updating Mileage',
    };

    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.updateMileageRequest.text = '';
    this.updateMileageRequest.vin = this.demoMileageModalData.vin;
    this.updateMileageRequest.statusCode = '00020';
    this.updateMileageRequest.km = this.updatedMileage.toString();

    this.stockService.updateMileage(this.updateMileageRequest).subscribe(
      (response) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.log('Mileage updated successfully:', response);
        this.demoMileageModalIsOpen = false;
        this.addToast('positive', response.returnMessages[0]?.messageText);
      },
      (error) => {
        this.addToast('critical', 'Mileage Update failed');
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.demoMileageModalIsOpen = false;
        console.error('Error updating mileage:', error);
      }
    );
  }

  updateMileageModalClicked(
    modelDescription: string | number,
    vin: string | number,
    mileage: string | number
  ) {
    this.updatedMileage = '';
    this.demoMileageModalData.modelDescription = modelDescription.toString();
    this.demoMileageModalData.vin = vin.toString();
    this.demoMileageModalData.currentMileage = mileage.toString();
    this.demoMileageModalIsOpen = true;
  }

  checkMileage(mileageModel: string, currentMileage: string) {
    if (mileageModel && currentMileage) {
      const mileageValue = parseFloat(mileageModel);
      const currentMileageValue = parseFloat(currentMileage);
      this.isMileageGreater = mileageValue <= currentMileageValue;
      if (!this.isMileageGreater) {
        this.updateMileage();
      }
      return;
    }
    this.isMileageGreater = false;
  }

  requestInspectionModalClicked(
    modelDescription: string | number,
    vin: string | number,
    appraisalStatus: string | number
  ) {
    this.requestInspectionModalData.modelDescription =
      modelDescription.toString();
    this.requestInspectionModalData.vin = vin.toString();
    this.requestInspectionModalData.appraisalStatus =
      appraisalStatus.toString();

    this.requestInspectionModalIsOpen = true;
  }

  requestInspection(
    vin: string,
    modelDescription: string,
    inspectionDateModel: string,
    inspectionTimeModel: string,
    appraisalStatus: string
  ) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Requesting Inspection',
    };
    if (!inspectionDateModel || !inspectionTimeModel) {
      this.addToast('critical', 'Inspection date and time are required');
      return;
    }
    this.inspectionRequest.vin = vin;
    this.inspectionRequest.productKey = this.getProductKey(appraisalStatus);
    this.inspectionRequest.appointmentDate = inspectionDateModel;
    this.inspectionRequest.appointmentTime = inspectionTimeModel;

    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.stockService.requestInspection(this.inspectionRequest).subscribe(
      (response) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.log('Inspection requested successfully:', response);
        this.requestInspectionModalIsOpen = false;
        this.addToast('positive', response.message);
      },
      (error) => {
        this.addToast('critical', 'Inspection Request failed');
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.error('Error requesting inspection:', error);
      }
    );
  }

  getProductKey(appraisalStatus: string): string {
    if (appraisalStatus === 'Report Uploaded') {
      return 'BMWSA.YUC.APPRAISAL.ADD';
    } else {
      return 'BMWSA.YUC.APPRAISAL';
    }
  }

  showInboundFooter: boolean = true;

  isPofRobotRed(pofRobot: string | number): boolean {
    return pofRobot === 'RED';
  }

  isPofRobotGreen(pofRobot: string | number): boolean {
    return pofRobot === 'GREEN';
  }

  isPofRobotAmber(pofRobot: string | number): boolean {
    return pofRobot === 'AMBER';
  }

  isPofAttachedX(pofAttached: string | number): boolean {
    return pofAttached === 'X';
  }

  getCampaignDetails(
    vin: string | number,
    deliveryStop: string | number,
    imageUrl: string | number,
    model: string | number
  ) {
    if (deliveryStop !== 'G' && deliveryStop !== '') {
      this.campaignDetails.getCampaignDetailsModalIsOpen(
        vin.toString(),
        model.toString(),
        imageUrl.toString(),
        deliveryStop.toString()
      );
    }
  }

  checkDemoDocIndictor(docIndicator: string | number) {
    if (docIndicator === '0') return 'rgba(254, 203, 0, 0.4)';
    if (docIndicator === 'R') return 'rgba(255, 0, 0, 0.4)';
    return undefined;
  }

  checkCampaignItem(deliveryStop: string | number): 'rgba(254, 203, 0, 0.4)' | 'rgba(255, 0, 0, 0.4)' | undefined {
    if (deliveryStop === 'Y') return 'rgba(254, 203, 0, 0.4)';
    if (deliveryStop === 'R') return 'rgba(255, 0, 0, 0.4)';
    return undefined;
  }

  // canDismissModal() {
  //   this.base64FileContent = '';
  //   this.selectedFile = null;
  //   this.mileageModel = '';
  //   this.model = null;
  //   //
  //   // console.log('Modal dismissed');
  //   // const fileInput = document.getElementById('file') as HTMLInputElement;
  //   // if (fileInput) {
  //   //   fileInput.value = '';
  //   // }
  //   this.inspectionDateModel = '';
  //   this.inspectionTimeModel = '';
  //   return true;
  // }
  closeOtpModal() {
    this.model = null;
    const fileInput = document.getElementById('file') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.otpModalIsOpen = false;
  }

  closeDemoMileageModal() {
    this.model = null;
    const fileInput = document.getElementById(
      'mileageText'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.demoMileageModalIsOpen = false;
  }

  closeRequestInspectionModal() {
    this.mileageModel = '';
    const inspectionDateInput = document.getElementById(
      'inspectionDate'
    ) as HTMLInputElement;
    if (inspectionDateInput) {
      inspectionDateInput.value = '';
    }
    const inspectionTimeInput = document.getElementById(
      'inspectionTime'
    ) as HTMLInputElement;
    if (inspectionTimeInput) {
      inspectionTimeInput.value = '';
    }
    this.requestInspectionModalIsOpen = false;
  }

  downloadInspectionReport(
    bmwOrderNumber: string | number,
    tuvSudRefNumber: string | number
  ) {
    //add loading
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Downloading Inspection Document',
    };
    this.inspectionDocRequest = {
      tuvSudReferenceNumber: tuvSudRefNumber.toString(),
      bmwOrderNumber: bmwOrderNumber.toString(),
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

    this.stockService.getInspectionDoc(this.inspectionDocRequest).subscribe(
      (response) => {
        console.log('Inspection Document Response:', response);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        if (response.errorMessage) {
          this.addToast('critical', response.errorMessage);
          return;
        }
        const decodedDoc = atob(response.document.toString()); // Decode the Base64 string
        const byteArray = new Uint8Array(decodedDoc.length);
        for (let i = 0; i < decodedDoc.length; i++) {
          byteArray[i] = decodedDoc.charCodeAt(i);
        }
        const blob = new Blob([byteArray], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      },
      (error) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.addToast('critical', 'Failed to download inspection document');
      }
    );
  }

  @ViewChild('vehicleDetailsModal') vehicleDetailsModal: any;
  @ViewChild('openVehicleModalBtn')
  openVehicleModalBtn!: ElementRef<HTMLButtonElement>;

  vehicleDetailsModalIsOpen = false;

  openVehicleDetailsModal(row: any) {
    this.selectedVehicle = row;
    this.vehicleDetailsModalIsOpen = true;
  }

  closeVehicleDetailsModal() {
    this.vehicleDetailsModalIsOpen = false;
  }
  licenseModalData = {
    modelDescription: '',
    vin: '',
  };
  uploadLicenseDocsModalIsOpen: boolean = false;

  dateConfig: Partial<DsDatepickerConfiguration> = { selectionMode: 'single' };
  viewDate = new Date();
  licenseDoc = '';
  regNumberModel = '';

  onRegNrTextChange($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.regNumberModel = input.value;
  }

  onLicenseDocFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        // Get Base64 string and remove the prefix
        const base64String = (reader.result as string).split(',')[1];
        this.licenseDoc = base64String;
      };
      reader.readAsDataURL(file);
    }
  }

  openLicenseUploadModal(vin: string | number, modelDes: string | number) {
    this.licenseModalData.vin = vin.toString();
    this.licenseModalData.modelDescription = modelDes.toString();
    this.uploadLicenseDocsModalIsOpen = true;
  }

  closeUploadLicenseDocsModal() {
    this.uploadLicenseDocsModalIsOpen = false;
    this.licenseModalData.vin = '';
    this.licenseModalData.modelDescription = '';
    this.licenseDoc = '';
    this.regNumberModel = '';
  }

  @Output() uploadSuccess = new EventEmitter<void>();

  uploadLicenseDocs() {

    this.loadingAreaConfig = {id: 'upload', loadingTitle: 'uploading'};
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

    const uploadRegRequest:UploadLicenseDocsRequest = {
      dealerCode: localStorage.getItem('dealerCode') || '',
      vin: this.licenseModalData.vin,
      licenseDate: this.viewDate.toDateString(),
      licenseDocuments: this.licenseDoc,
      registrationNumber: this.regNumberModel,

    }
    if (
      !uploadRegRequest.vin ||
      !uploadRegRequest.licenseDate ||
      !uploadRegRequest.licenseDocuments ||
        !uploadRegRequest.registrationNumber
    ) {
      this.addToast('critical', 'All fields are required');
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      return;
    }

    this.stockService.uploadLicenseDocs(uploadRegRequest).subscribe(
      (response) => {
        this.addToast(
          response.message && response.message.toLowerCase().includes('successfully') ? 'positive' : 'critical',
          response.message
        );
        this.uploadLicenseDocsModalIsOpen = false;
        this.licenseDoc = '';
        this.regNumberModel = '';
        this.cdr.detectChanges();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        setTimeout(() => {
          this.uploadSuccess.emit();
        }, 4000);
      },
      (error) => {
        console.log(error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.uploadLicenseDocsModalIsOpen = false;
        this.licenseDoc = '';
        this.regNumberModel = '';
        this.addToast('critical', 'Failed to upload vehicle registration document');
      }
    );
  }


}
